import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { dataTableSectionSx } from "common/Components/DataTable/DataTable.styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";

const uiFont = appThemeFonts.family.ui;
const numericFont = appThemeFonts.family.numeric;

export const CustomersPageRoot = styled(Box)({
  ...dataTableSectionSx,
  fontFamily: uiFont,
});

export const AddCustomerButton = styled(Button)(() => ({
  height: "38px",
  padding: "0 18px",
  backgroundColor: appThemeColors.text.lightBlue,
  borderRadius: appThemeRadius.pill,
  boxShadow: "none",
  textTransform: "none",
  fontFamily: uiFont,
  fontSize: "13.5px",
  fontWeight: 600,
  color: appThemeColors.neutral.white,
  gap: "8px",
  "& .MuiButton-startIcon": {
    margin: 0,
    "& > *:nth-of-type(1)": {
      fontSize: 16,
    },
  },
  "&:hover": {
    boxShadow: "none",
    backgroundColor: appThemeColors.text.heading,
  },
  "&:focus-visible": {
    outline: "2px solid #0B5FA5",
    outlineOffset: "2px",
  },
}));

export const CustomersTableFrame = styled(Box)({
  ...dataTableSectionSx,
  fontFamily: uiFont,
});

export const ResultsBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "14px",
  flexWrap: "wrap",
  rowGap: "8px",
  marginBottom: "12px",
});

export const ResultsSummary = styled(Typography)({
  fontFamily: numericFont,
  fontSize: "13px",
  color: appThemeColors.text.muted,
  margin: 0,
  fontVariantNumeric: "tabular-nums",
});

export const ClearFiltersButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "$active",
})(({ $active }) => ({
  height: 34,
  padding: "0 15px",
  background: appThemeColors.background.paper,
  border: `1px solid ${
    $active ? appThemeColors.border.strong : appThemeColors.border.default
  }`,
  borderRadius: appThemeRadius.pill,
  color: $active ? appThemeColors.text.primary : appThemeColors.text.faintLight,
  fontSize: "12.5px",
  fontWeight: 500,
  cursor: $active ? "pointer" : "default",
  fontFamily: uiFont,
  "&:hover": $active
    ? {
        backgroundColor: appThemeColors.background.kbd,
        borderColor: appThemeColors.text.lightBlue,
      }
    : undefined,
  "&:disabled": {
    cursor: "default",
  },
}));

export const CustomerNameLink = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "13px",
  fontWeight: 500,
  color: appThemeColors.blue.dark,
  textDecoration: "underline",
  textUnderlineOffset: "2px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  cursor: "pointer",
  lineHeight: 1.35,
});

export const CustomerCodeText = styled(Typography)({
  fontFamily: numericFont,
  fontSize: "12.5px",
  color: appThemeColors.text.muted,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  lineHeight: 1.35,
});

export const CustomerStatusCell = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  minWidth: 0,
});

export const CustomerStatusLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$active",
})(({ $active }) => ({
  fontFamily: uiFont,
  fontSize: "13px",
  fontWeight: 500,
  lineHeight: 1.35,
  whiteSpace: "nowrap",
  color: $active
    ? appThemeColors.text.lightBlue
    : appThemeColors.text.faint
}));

export const InactiveCustomerTitleStatus = styled("span")({
  marginLeft: 6,
  verticalAlign: "middle",
});
